export function vlozitDoKosiku(polozka) {
  return { type: "ADD", payload: polozka };
}
export function ukazKosik() {
  return { type: "SWOW" };
}
